module.exports = __webpack_public_path__ + "images/emoji/u5408.f095923db87c3cf8b23b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/u5408.png
// module id = JUIx
// module chunks = 13